import { useState } from 'react';
import { Box, Grid } from '@mui/material';
import { useField } from 'react-final-form';

import { ChipGroupField } from '@occc-app/design-system';
import { Typography } from '@occc/ui-design-system';
import { WEEKDAY } from '@occc-app/lib/util-location-schedule/location-schedule.types';

import { ScheduleTimePicker } from './schedule-time-picker.component';

import {
  weekdayChipGroupOptions,
  sortToWeekdaySequence,
} from '../retailer-network-location-update-page.utils';

export const StoreSchedule = () => {
  const openAllDayField = useField<WEEKDAY[]>('availableDays');
  const scheduleField = useField('schedule');
  const openAllDayFieldValue = openAllDayField.input.value;
  const scheduleFieldValue = scheduleField.input.value;
  const [selectedDaysCount, setSelectedDaysCount] = useState(openAllDayFieldValue.length);

  // If we add or remove days, we need to update the schedule values
  if (selectedDaysCount !== openAllDayFieldValue.length) {
    const nextScheduleValues = openAllDayFieldValue.reduce((acc, day) => {
      return {
        ...acc,
        [day]: scheduleFieldValue[day] || {},
      };
    }, {});

    scheduleField.input.onChange(nextScheduleValues);
    setSelectedDaysCount(openAllDayFieldValue.length);
  }

  return (
    <Box paddingBottom={3} paddingRight={3}>
      <Grid container marginTop={3} marginX={3}>
        <Grid item xs={2}>
          <Typography justifySelf='start' variant='body1' component='h3' marginBottom={2}>
            Open on
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <ChipGroupField name='availableDays' options={weekdayChipGroupOptions} />
        </Grid>
      </Grid>
      <Grid container>
        {sortToWeekdaySequence(openAllDayFieldValue).map((day) => (
          <Grid item key={day} xs={12}>
            <ScheduleTimePicker day={day} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
